import {Component, ReactNode} from 'react';
import * as Sentry from '@sentry/react';
import isProduction from '@/utils/isProduction';
import ErrorView from './ErrorView';

type State = {
  error: null | Error;
};

type Props = {
  children: ReactNode;
};

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {error: null};
  }

  static getDerivedStateFromError(error: Error | null) {
    // Update state so the next render will show the fallback UI.
    return {error};
  }

  componentDidCatch(error: Error) {
    if (isProduction()) {
      Sentry.captureException(error);
    }
  }

  render() {
    if (this.state.error) {
      return <ErrorView />;
    }

    return this.props.children;
  }
}
